<template>
  <div style="position: relative; height: 300px">
    <div class="dinwdw">
      <div class="name_boxr">账号：</div>
      <div>
        <el-button type="primary" size="mini" @click="choose">选择</el-button>
        <el-tag
          v-if="account_id"
          style="margin-right: 10px; margin-bottom: 5px"
          closable
          :type="'success'"
          @close="rightclicktwoGroup(admincode.name, 1)"
        >
          {{ admincode.name }}
        </el-tag>
      </div>
    </div>
    <div class="item">
      <span class="title" />
      <div style="flex: 1">
        <el-date-picker
          v-model="date1"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        />
        <!-- <div class="block">
          <el-date-picker
            v-model="date"
            type="daterange"
            align="right"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </div> -->
      </div>
    </div>
    <div class="butpostion">
      <el-button
        :loading="submitLoading"
        type="primary"
        plain
        @click="submit"
      >提交</el-button>
    </div>
    <el-dialog
      title="选择账号id"
      :visible.sync="dialogAccount_id"
      width="800px"
      append-to-body
    >
      <dialogAccount ref="Account" @bandarr="bandarrcode" />
    </el-dialog>
  </div>
</template>

<script>
import dialogAccount from './dialogAccount_id.vue'
export default {
  components: {
    dialogAccount
  },
  data() {
    return {
      submitLoading: false,
      pickerOptions: {
        disabledDate(time) {
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          return time.getTime() !== today.getTime()
        }
      },
      date1: this.getNowFormatDate(window.Date.now()),
      date: [
        this.getNowFormatDate(window.Date.now()),
        this.getNowFormatDate(window.Date.now())
      ], // 默认日期范围为一个月
      account_id: '',
      dialogAccount_id: false,
      datas: {}
    }
  },
  methods: {
    bandarrcode(arr) {
      console.log('arr:', arr)
      this.dialogAccount_id = false
      const item = {
        name: arr.account_name,
        id: arr.id
      }
      this.account_id = arr.id

      this.admin = {}
      this.admincode = item
    },
    rightclicktwoGroup(item, indexr) {
      console.log(item, indexr)
      this.admincode = {}
      this.account_id = ''
    },
    choose() {
      this.dialogAccount_id = true
      this.$nextTick(() => {
        this.$refs.Account.sendr(this.account_id, this.datas.id)
      })
    },
    submit() {
      console.log('this.date1:', this.date1)
      if (this.date1 === '' || this.date1 === null) {
        return this.$message('请选择时间')
      }
      if (this.account_id === '') {
        return this.$message('请选择账户id')
      }
      //   if (this.date === null) {
      //     return this.$message('请选择时间')
      //   }
      this.submitLoading = true
      const obj = {
        // start_time: this.date && this.date.length ? this.date[0] : null,
        // end_time: this.date && this.date.length ? this.date[1] : null,
        start_time: this.date1,
        end_time: this.date1,
        account_id: this.account_id
      }
      this.$emit('callbackbacer', obj)
      this.submitLoading = false
      this.account_id = ''
      this.admincode = {}
    },

    send(row) {
      console.log('row:', row)
      this.datas.id = row.id
    },
    getNowFormatDate(timeStamp) {
      var date = new Date(timeStamp)
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    }
  }
}
</script>

<style scoped lang="less">
.item {
  display: flex;
  align-items: center;
  margin-right: 20px;

  .item_title {
    margin-right: 10px;
    display: inline-block;
  }
  .item_input {
    width: 200px;
  }
}
.butpostion {
  position: absolute;
  top: 180px;
  right: 200px;
}
.dinwdw {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.name_boxr {
  color: rgb(169, 162, 151);
  font-size: 14px;
  text-align: right;
  flex-shrink: 0;
}
</style>
